var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend"},[_c('a',{staticClass:"legend-toggle",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.shown = !_vm.shown}}},[_vm._v(_vm._s(!_vm.shown ? "Show Legend" : "Hide Legend"))]),(_vm.shown)?_c('div',_vm._l((_vm.$options.constants
        .SCHOLIA_KIND_CHOICES),function(ref,kindIdx){
        var kindName = ref[0];
        var kindLabel = ref[1];
return _c('div',{key:kindIdx,staticClass:"legend-item"},[_c('Icon',{class:kindName,attrs:{"name":'square'}}),_vm._v(_vm._s(kindLabel)+" ")],1)}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }